// Engine-freie Helfer für die Mehrfachauswahl: Duplizieren mit Id-Remap
// sowie Verschieben/Material-Zuweisung als Batch-Updates (je ein Undo-Schritt
// über UpdatePartsCommand bzw. CompositeCommand im Controller).

import { newPart, generateClientId } from "./document"

// Kopien aller Teile mit Versatz und frischen client_ids. meta wird 1:1
// übernommen, aber Verweise werden konsistent gehalten:
// - meta.attached_to innerhalb der Auswahl → zeigt auf die neue Kopie des
//   Ankers; zeigt der Anker nach außerhalb, entfällt der Verweis.
// - meta.cabinet_id: gehört der Gruppen-Anker (Teil mit meta.cabinet) zur
//   Auswahl, bilden die Kopien eine eigene Gruppe mit frischer Id — sonst
//   scheiden die Kopien aus der Korpusgruppe aus.
// - meta.group (Baugruppe, ankerlos): jede Gruppe im Satz bekommt eine
//   frische Id — die Kopien bilden eine eigene Baugruppe gleichen Namens,
//   statt sich ans Original zu hängen.
export function duplicatedParts(parts, offset = { x: 20, y: 0, z: 20 }) {
  const idMap = new Map()
  const groupIdMap = new Map(parts
    .filter((part) => part.meta?.cabinet && part.meta?.cabinet_id)
    .map((part) => [ part.meta.cabinet_id, generateClientId() ]))
  const assemblyIdMap = new Map()

  const copies = parts.map((part) => {
    const copy = newPart({
      ...structuredClone(part),
      client_id: undefined,
      pos_x: part.pos_x + (offset.x ?? 0),
      pos_y: part.pos_y + (offset.y ?? 0),
      pos_z: part.pos_z + (offset.z ?? 0)
    })
    idMap.set(part.client_id, copy.client_id)
    return copy
  })

  for (const copy of copies) {
    const meta = copy.meta
    if (!meta) continue
    if ("attached_to" in meta) {
      if (idMap.has(meta.attached_to)) meta.attached_to = idMap.get(meta.attached_to)
      else delete meta.attached_to
    }
    if ("cabinet_id" in meta) {
      if (groupIdMap.has(meta.cabinet_id)) meta.cabinet_id = groupIdMap.get(meta.cabinet_id)
      else delete meta.cabinet_id
    }
    if (meta.group?.id) {
      if (!assemblyIdMap.has(meta.group.id)) assemblyIdMap.set(meta.group.id, generateClientId())
      meta.group = { ...meta.group, id: assemblyIdMap.get(meta.group.id) }
    }
  }
  return copies
}

// Updates für „Verschieben um Delta“ (mm; y = Höhe, z = Tiefe)
export function batchMoveUpdates(parts, delta) {
  const { x = 0, y = 0, z = 0 } = delta
  return parts.map((part) => ({
    clientId: part.client_id,
    attrs: { pos_x: part.pos_x + x, pos_y: part.pos_y + y, pos_z: part.pos_z + z }
  }))
}

// Updates für die Material-Zuweisung an alle gewählten Teile
export function batchMaterialUpdates(parts, materialId) {
  return parts.map((part) => ({ clientId: part.client_id, attrs: { material_id: materialId } }))
}
